import { render, staticRenderFns } from "./NewLineupForm.vue?vue&type=template&id=7c564f16&"
import script from "./NewLineupForm.vue?vue&type=script&lang=ts&"
export * from "./NewLineupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports